import React from 'react';

function Biller() {
  return (
    <svg width="15" height="26" viewBox="0 0 15 26" xmlns="http://www.w3.org/2000/svg">
      <g stroke="currentColor" fill="none" fillRule="evenodd">
        <path d="M4.357 11.534A5.48 5.48 0 0 1 1 6.48C1 3.453 3.45 1 6.474 1a5.477 5.477 0 0 1 5.473 5.48c0 3.026-2.45 5.48-5.473 5.48" />
        <path d="M5.383 9.904V3.74h1.71c2.053 0 2.053 2.74 0 2.74h-3.08M4 8h4.447" />
        <path d="M6.75 17.78v-6.506c0-1.826-2.394-1.826-2.394 0v7.876m0 1.713v-2.055c0-1.68-2.394-1.68-2.394 0v3.082c0 .406.16.794.446 1.08l1.16 1.16c.285.287.446.675.446 1.08V26m2.737-9.932c0-1.826 2.396-1.826 2.396 0v1.713m0 0v-1.49c0-1.68 2.395-1.68 2.395 0v1.634" />
        <path d="M11.54 17.78v-1.027c0-1.84 2.395-1.84 2.395 0v2.005L14 22.5c0 1-1 1.5-1.5 2V26" />
      </g>
    </svg>
  );
}

export default Biller;
